// Static site — images served from /images/
export const photoUrl = (name) => `/images/${name}.jpg`;

// Static settings (no backend)
export const STATIC_SETTINGS = { nightly_rate: 1550, currency: "NZD", min_nights: 3 };

// Admin auth stubs
export const getToken = () => null;
export const setToken = () => {};
export const clearToken = () => {};
export const api = {
  get: () => Promise.reject(new Error("No backend")),
  post: () => Promise.reject(new Error("No backend")),
};

// Legacy exports
export const API = "";
